import { globals } from '../../globals'

// ------------------------------------
// Constants
// ------------------------------------
export const GET_CLIENT_CONTACTS_START = 'GET_CLIENT_CONTACTS_START'
export const CLIENT_CONTACTS_FETCHED = 'CLIENT_CONTACTS_FETCHED'
export const GET_CLIENT_CONTACTS_FAILED = 'GET_CLIENT_CONTACTS_FAILED'
export const CLEAR_CONTACTS = 'CLEAR_CONTACTS'
export const UPDATE_CONTACT_DATA = 'UPDATE_CONTACT_DATA'
// ------------------------------------
// Actions
// ------------------------------------
export const actions = {
  getClientContacts
}

export function updateContactData (location, valueType, valueID, fieldValue) {
  return {
    type: UPDATE_CONTACT_DATA,
    location,
    valueType,
    payload: {
      value: valueID,
      fieldValue: fieldValue,
    }
  }
}

export function getClientContacts (clientId) {
  return (dispatch) => {
    dispatch({ type: CLEAR_CONTACTS })
    dispatch({ type: GET_CLIENT_CONTACTS_START })
    const headers = {
      'Content-Type': 'application/json',
    }
    const options = {
      method: 'GET',
      credentials: 'include',
      headers,
    }
    fetch(`${globals.apiUrl}/api/clientcontact?clientid=${clientId}`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      } else if (response.status === 404) {
        dispatch({
          type: GET_CLIENT_CONTACTS_FAILED,
          payload: {
            json: [],
          },
        })
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: CLIENT_CONTACTS_FETCHED,
          payload: {
            json,
          },
        })
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: GET_CLIENT_CONTACTS_FAILED })
    })
  }
}

function returnContacts (data) {
  let newObjectContacts = {}
  for (let i = 0; i <= data.length - 1; i++) {
    let newSelected = []
    const IsPrimary = data[i].IsPrimary
    const IsSignatory = data[i].IsSignatory
    const IsBilling = data[i].IsBilling
    const IsTechnical = data[i].IsTechnical
    if (IsSignatory) {
      newSelected = [...newSelected, 'IsSignatory']
    }
    if (IsPrimary) {
      newSelected = [...newSelected, 'IsPrimary']
    }
    if (IsBilling) {
      newSelected = [...newSelected, 'IsBilling']
    }
    if (IsTechnical) {
      newSelected = [...newSelected, 'IsTechnical']
    }
    newObjectContacts[data[i].ClientContactId] = {
      selected: newSelected,
      textValues: {},
    }
    newObjectContacts[0] = {
      selected: [],
      textValues: {},
    }
  }
  return newObjectContacts
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [GET_CLIENT_CONTACTS_START] : (state) => {
    return {
      ...state,
    }
  },
  [CLIENT_CONTACTS_FETCHED] : (state, action) => {
    const { json } = action.payload
    return {
      ...state,
      renderData: {
        ...state.renderData,
        clientContacts: json,
      },
      formDataValue: {
        ...state.formDataValue,
        clientContacts: returnContacts(json),
      }
    }
  },
  [GET_CLIENT_CONTACTS_FAILED] : (state) => {
    return {
      ...state,
      renderData: {
        ...state.renderData,
      },
    }
  },
  [CLEAR_CONTACTS] : () => {
    return {
      ...initialState,
    }
  },
  [UPDATE_CONTACT_DATA] : (state, action) => {
    switch (action.valueType) {
      case 'ch': {
        // mark single checkbox as checked
        const { value } = action.payload
        const { id } = action.location
        let resultedSelectedArray = []
        resultedSelectedArray = Array.isArray(value)
          ? [...state.formDataValue.clientContacts[id].selected, ...value]
          : [...state.formDataValue.clientContacts[id].selected, value]
        return {
          ...state,
          formDataValue: {
            ...state.formDataValue,
            clientContacts: {
              ...state.formDataValue.clientContacts,
              [id]: {
                ...state.formDataValue.clientContacts[id],
                selected: resultedSelectedArray
              }
            },
          }
        }
      }

      case 'ch_uncheck': {
        // uncheck single checkbox
        const { id } = action.location
        const { value } = action.payload
        let resultedSelectedArray = state.formDataValue.clientContacts[id].selected
        if (Array.isArray(value)) {
          for (let i = 0; i < value.length; i++) {
            resultedSelectedArray = resultedSelectedArray.filter(function (element) {
              return element !== value[i]
            })
          }
        } else {
          const idIndex = state.formDataValue.clientContacts[id].selected.indexOf(value)
          resultedSelectedArray = [
            ...resultedSelectedArray.slice(0, idIndex),
            ...resultedSelectedArray.slice(idIndex + 1)
          ]
        }
        return {
          ...state,
          formDataValue: {
            ...state.formDataValue,
            clientContacts: {
              ...state.formDataValue.clientContacts,
              [id]: {
                ...state.formDataValue.clientContacts[id],
                selected: resultedSelectedArray
              }
            },
          }
        }
      }

      case 'textinput' : {
        // set text value
        const { id } = action.location
        const { value, fieldValue } = action.payload
        return {
          ...state,
          formDataValue: {
            ...state.formDataValue,
            clientContacts: {
              ...state.formDataValue.clientContacts,
              [id]: {
                ...state.formDataValue.clientContacts[id],
                textValues: {
                  ...state.formDataValue.clientContacts[id].textValues,
                  [value]: fieldValue,
                }
              }
            }
          }
        }
      }
    }
  }
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  errorCode: '',
  renderData: {},
  formDataValue: {
    clientContacts: {
      0: {
        selected: [],
        textValues: {}
      }
    }
  }
}
export default function clientContactsReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/reducers/clientContacts.js